import type { ItemFailureReason } from '../client';

type PlayerError =
    | {
          code?: number;
          message?: string;
          metadata?: { errorType?: string };
      }
    | null
    | undefined;

// Maps a video.js error to the API's failure reasons. VHS reports a stream
// without any loadable playlist with code 3 (decode) as well, so that message
// counts as a load failure. Aborted loads are not content failures.
export function failureReason(error: PlayerError): ItemFailureReason | null {
    if (!error || error.code === 1) return null;

    const type = error.metadata?.errorType ?? '';
    if (type.startsWith('network')) return 'playback.load_failed';
    if (/append|transmux|decrypt/.test(type)) return 'playback.decode_failed';
    if (
        error.code === 3 &&
        !error.message?.startsWith('Playback cannot continue')
    )
        return 'playback.decode_failed';

    return 'playback.load_failed';
}
